<template>
  <form
    autocomplete="off"
    class="admin-loan-types-form"
    @reset.prevent="handleCancel"
    @submit.prevent="handleSave"
  >
    <fieldset>
      <label>
        <span class="required">Loan Type</span>

        <input
          :disabled="disabled"
          id="admin-loan-type-name"
          required
          type="text"
          v-model.trim="name"
        />
      </label>
    </fieldset>

    <footer>
      <button
        :disabled="!isDeleteEnabled"
        id="admin-loan-type-delete"
        type="button"
        @click="handleDelete"
        v-if="canDelete && loanType.id"
      >Delete</button>

      <button :disabled="!isSaveEnabled" id="admin-loan-type-save" type="submit" v-if="canSave">Save</button>

      <button
        :disabled="!isCancelEnabled"
        id="admin-loan-type-cancel"
        type="reset"
        v-if="canCancel"
      >Cancel</button>
    </footer>
  </form>
</template>

<script>
import { deleteLoanType, saveLoanType } from "../../api/LoanAPI";

export default {
  data() {
    return {
      name: undefined
    };
  },

  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    loanType: {
      type: Object
    }
  },

  computed: {
    canCancel() {
      return true;
    },
    canDelete() {
      return this.can("DELETE_LOAN_TYPES");
    },
    canSave() {
      return this.can({ permissions: ["CREATE_LOAN_TYPES", "UPDATE_LOAN_TYPES"], matchAny: true });
    },
    isCancelEnabled() {
      return !this.disabled;
    },
    isDeleteEnabled() {
      return !this.disabled && this.loanType?.id;
    },
    isSaveEnabled() {
      return (
        !this.disabled &&
        (this.loanType?.id
          ? this.can("UPDATE_LOAN_TYPES")
          : this.can("CREATE_LOAN_TYPES"))
      );
    }
  },

  methods: {
    handleCancel() {
      this.$emit("cancel");
    },
    async handleDelete() {
      if (!confirm("Are you sure you want to delete this loan type?")) {
        return;
      }

      await deleteLoanType(this.loanType);
      this.$emit("delete", this.loanType);
    },
    async handleSave() {
      try {
        this.$emit(
          "save",
          await saveLoanType({
            ...this.loanType,
            name: this.name
          })
        );
      } catch (e) {
        this.showErrors(e, "A loan type");
      }
    },
    isDirty() {
      if (this.disabled) {
        return false;
      }

      return this.name !== this.loanType?.name;
    }
  },

  watch: {
    disabled(to, from) {
      !to && from && this.autofocus();
    },
    loanType: {
      immediate: true,
      handler(to, from) {
        if (to !== from) {
          this.name = to?.name;
        }

        !this.disabled && this.autofocus();
      }
    }
  }
};
</script>

<style>
.admin-loan-types-form {
  display: grid;
  grid-column-gap: 1em;
  grid-row-gap: 0.5em;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.admin-loan-types-form > footer {
  grid-column: span 2;
  margin: 0;
  padding: 0.5em 0 0 0;
}
</style>